import { render, staticRenderFns } from "./AdminAppPackage.vue?vue&type=template&id=4c61edc0&scoped=true"
import script from "./AdminAppPackage.vue?vue&type=script&lang=js"
export * from "./AdminAppPackage.vue?vue&type=script&lang=js"
import style0 from "./AdminAppPackage.vue?vue&type=style&index=0&id=4c61edc0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61edc0",
  null
  
)

export default component.exports